import { Button } from '~/components/ui/Button';
import { teamPricingPlansStore } from '~/lib/stores/pricing/teamPlans';

export const NoTeamScreen = () => {
  const handleCreateTeamPlan = () => {
    teamPricingPlansStore.startCreateTeamFlow();
  };
  return (
    <div className="flex flex-col gap-4 items-center h-full justify-center">
      <div className="i-ph:users-three text-bolt-ds-text-secondary w-6 h-6" />
      <div className="text-bolt-ds-text-secondary text-sm text-center max-w-80">
        You don't belong to a team, ask an admin for an invitation or upgrade to a Team plan.
      </div>
      <Button onClick={handleCreateTeamPlan}>Create a Team plan</Button>
    </div>
  );
};
